import { assertNever, CheckedAddress } from '@sparkdotfi/common-universal'

import { SpkAirdropSkeleton } from './components/skeleton/SpkAirdropSkeleton'
import { useSpkAirdrop } from './logic/useSpkAirdrop'
import { CheckEligibilityView } from './views/CheckEligibilityView'
import { DashboardView } from './views/DashboardView'
import { ErrorView } from './views/ErrorView'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { withErrorBoundary } from '@/ui/utils/withErrorBoundary'
import { withSuspense } from '@/ui/utils/withSuspense'

function SpkAirdropContainer() {
  const spkAirdropData = useSpkAirdrop()

  switch (spkAirdropData.view) {
    case 'check-eligibility':
      return <CheckEligibilityView {...spkAirdropData.checkEligibilityViewProps} />
    case 'airdrop-dashboard':
      return <DashboardView {...spkAirdropData.airdropDashboardViewProps} />
    default:
      assertNever(spkAirdropData)
  }
}

function SpkAidropContainerWithKey() {
  const { account = CheckedAddress.ZERO() } = useConnectedAddress({ throwOnNotConnected: false })

  return <SpkAirdropContainer key={account} />
}

const SpkAirdropContainerWithSuspense = withSuspense(SpkAidropContainerWithKey, SpkAirdropSkeleton)
const SpkAirdropContainerWithErrorBoundary = withErrorBoundary(SpkAirdropContainerWithSuspense, ErrorView)
export { SpkAirdropContainerWithErrorBoundary as SpkAirdropContainer }
